/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * In-memory cache for user → organization ID (avoids redundant derivation from Clerk).
 */

const cache = new Map<string, { orgId: string; timestamp: number }>();

export const ORG_DATA_CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

export function getOrgFromCache(userId: string): string | null {
  const entry = cache.get(userId);
  if (!entry) return null;
  if (Date.now() - entry.timestamp >= ORG_DATA_CACHE_TTL_MS) {
    cache.delete(userId);
    return null;
  }
  return entry.orgId;
}

export function setOrgInCache(userId: string, orgId: string): void {
  cache.set(userId, { orgId, timestamp: Date.now() });
}

export function clearOrgCache(): void {
  cache.clear();
}
